import { HistoryOptions } from '@ryusei/code';


/**
 * The default options for the History component.
 *
 * @since 0.1.0
 */
export const DEFAULT_OPTIONS: HistoryOptions = {
  limit   : 100,
  debounce: 300,
};
